import React from 'react';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

function CardBlogPost(props) {

    const {t, i18n} = useTranslation();

    const item = props.data;

    const dataFormat = (data) => {
        let _data = data.split('-');
        return _data[2] + '.' + _data[1] + '.' + _data[0];
    }

    return (
        <div className="w-100 border-bottom p-2">
            <div className={'p-2 rounded d-flex flex-wrap align-items-center justify-content-between'}>
                <small className="text-secondary">
                    {item?.year ?? 'dd/mm/YYYY'}
                </small>
                <div className="col-md-7 col-12 text-start">
                    <small className="text-secondary">
                        {item?.type ?? ''}
                    </small>
                    <h4 className={'text-dark-emphasis'}>
                        <b>
                            {
                                i18n.language === 'ua' ? item?.title : item?.title_en ?? 'Title'
                            }
                        </b>
                    </h4>
                </div>
                <Link to={item?.link ?? '#'} target={'_blank'} className={'nav-link'}>
                    <b>{t(props.label ? props.label : 'title.read.more')} </b>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                         className="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                    </svg>
                </Link>
                {/*{*/}
                {/*    item?.url != null && <div className="links text-start d-flex flex-column">*/}
                {/*        <object data={item.url} type="application/pdf" height={'250'} className={'img-fluid'}>*/}
                {/*            <p>{item.name}</p>*/}
                {/*        </object>*/}

                {/*        <Link to={item.url} target={'_blank'}*/}
                {/*              className={'nav-link'}>*/}
                {/*            <small>{item.name}*/}
                {/*                <small className="text-secondary">*/}
                {/*                    {' ' + dataFormat(item.data)}*/}
                {/*                </small>*/}
                {/*            </small>*/}
                {/*        </Link>*/}
                {/*    </div>*/}
                {/*}*/}
            </div>
        </div>
    );
}

export default CardBlogPost;
